import {
  Editor,
  Transforms,
  Element as SlateElement,
} from 'slate'
import isHotkey from 'is-hotkey'

const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify']
const LIST_TYPES = ['numbered-list', 'bulleted-list']
const HOTKEYS = {
  'mod+b': 'bold',
  'mod+i': 'italic',
  'mod+u': 'underline',
  'mod+`': 'code',
}

class EditorService {
  constructor () {
    this.isBlockActive = this.isBlockActive.bind(this)
    this.isMarkActive = this.isMarkActive.bind(this)
    this.toggleBlock = this.toggleBlock.bind(this)
    this.toggleMark = this.toggleMark.bind(this)
  }

  focusEditor (editor) {
    document.querySelector('.editable-slate-element').focus()
    Transforms.select(editor, Editor.end(editor, []))
  }

  isBlockActive (editor, format, blockType = 'type') {
    const { selection } = editor
    if (!selection) return false
  
    const [match] = Array.from(
      Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: n =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n[blockType] === format,
      })
    )
    return !!match
  }

  toggleBlock (editor, format) {
    const isActive = this.isBlockActive(
      editor,
      format,
      TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type'
    )
    const isList = LIST_TYPES.includes(format)
  
    Transforms.unwrapNodes(editor, {
      match: n =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        LIST_TYPES.includes(n.type) &&
        !TEXT_ALIGN_TYPES.includes(format),
      split: true,
    })
    let newProperties
    if (TEXT_ALIGN_TYPES.includes(format)) {
      newProperties = {
        align: isActive ? undefined : format,
      }
    } else {
      newProperties = {
        type: isActive ? 'paragraph' : isList ? 'list-item' : format,
      }
    }
    Transforms.setNodes(editor, newProperties)
  
    if (!isActive && isList) {
      const block = { type: format, children: [] }
      Transforms.wrapNodes(editor, block)
    }
  }

  isMarkActive (editor, format) {
    const marks = Editor.marks(editor)
    if (format === 'color') return marks ? typeof marks[format] === 'string' : false
    return marks ? marks[format] === true : false
  }

  toggleMark (editor, format, color) {
    // Transforms.select(editor, Editor.end(editor, []))
    const isActive = this.isMarkActive(editor, format)
    if (isActive) {
      Editor.removeMark(editor, format)
    } else {
      Editor.addMark(editor, format, color || true)
    }
  }

  onKeyDownHandler (event, editor) {
    for (const hotkey in HOTKEYS) {
      if (isHotkey(hotkey, event)) {
        event.preventDefault()
        const mark = HOTKEYS[hotkey]
        this.toggleMark(editor, mark)
      }
    }
  }
}

export default new EditorService()
